/* Model */
class OrganizationModel extends App.Models.BaseModel {
    modelUrl = 'Organization';
}

App.Models.Organization = OrganizationModel;

/* Collection */
class OrganizationCollection extends App.Collections.BaseCollection {
    url = 'Organization';
    model = App.Models.Organization;
}

App.Collections.Organizations = OrganizationCollection;

/* Router */
class OrganizationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Organization';
        const model = App.Models.Organization;
        const collectionClass = App.Collections.Organizations;

        super(entityName, model, collectionClass);
    }

    beforeValidate = (form) => {
        const fields = App.Forms.Organization.form.fields;
        const listenerOrganization = fields.listenerOrganizations;
        if (form.fields.id) {
            const id = form.fields.id.value;
            listenerOrganization.dataIsInvalid = (function (id) {
                return function () {
                    this.dataInvalidErrorText = "Organization.Listener.CannotListenItself";
                    return this.getValue().filter(function (value) {
                        return (value.id === id) ? true : false;
                    }).length;
                };
            }(id));
        }
    }
}

App.Routers.Organization = OrganizationRouter;
